module.exports = __webpack_public_path__ + "img/banner-3-2@2x.aa5c20c7.jpg";